export default __webpack_public_path__ + "static/media/img-3.35b08eec.jpg";